import { Form } from "react-bootstrap";

import { Card, GridForm, GridFormItemWrapper } from "@bagel-web/components";

import { PlaygroundRoleConfig } from "../../types";

// The Role card: the core and characterization text, written through on
// every keystroke.
const RoleCard = ({
  roleConfig,
  onChange,
}: {
  roleConfig: PlaygroundRoleConfig | null | undefined;
  onChange: (patch: Partial<PlaygroundRoleConfig>) => void;
}) => (
  <Card title="Role">
    <GridForm $width="100%" $numCols={2}>
      <GridFormItemWrapper>
        <Form.Label htmlFor="playground-role-core">Core</Form.Label>
        <Form.Control
          id="playground-role-core"
          as="textarea"
          rows={10}
          value={roleConfig?.core ?? ""}
          onChange={(event) => onChange({ core: event.target.value })}
        />
      </GridFormItemWrapper>
      <GridFormItemWrapper>
        <Form.Label htmlFor="playground-role-characterization">
          Characterization
        </Form.Label>
        <Form.Control
          id="playground-role-characterization"
          as="textarea"
          rows={10}
          value={roleConfig?.characterization ?? ""}
          onChange={(event) =>
            onChange({ characterization: event.target.value })
          }
        />
      </GridFormItemWrapper>
    </GridForm>
  </Card>
);

export default RoleCard;
